export default __webpack_public_path__ + "static/media/gif2.8d2b7491.gif";